<template>
    <div class="content-heading">
        <i class="ic-head-icon">
            <img src="@/assets/images/sidebar/engagement.svg" alt="Engagement Icon">
        </i>
        <h4 class="head-title">Engagement</h4>
        <i class="ic-tooltip" id="help"></i>
        <b-popover target="help"
                triggers="hover"
                content="Connect with your registered customers via SMS, APP Push Notifications, and Email.">
        </b-popover>
        <div class="head-tabs">
            <b-nav tabs>
                <b-nav-item :to="{ path: '/engagement/broadcasting'}" v-if="permission.hasAccess('engagement.broadcasting')">
                    Broadcasting
                </b-nav-item>
                <b-nav-item :to="{ path: '/engagement/news' }" v-if="permission.hasAccess('engagement.news') && (planId != 1 && planId != 2)">
                    News
                </b-nav-item>
                <b-nav-item :to="{ name: 'engagementNewsPopUp' }" v-if="permission.hasAccess('engagement.news') && (planId != 1 && planId != 2)">
                    News &amp; Pop up
                </b-nav-item>
                <b-nav-item :to="{ path: '/engagement/survey' }" v-if="permission.hasAccess('engagement.survey')">
                    Survey
                </b-nav-item>
                <b-nav-item :to="{ path: '/engagement/notifications' }" v-if="permission.hasAccess('engagement.notifications')">
                    Notifications
                </b-nav-item>
                <template v-if="(env == 'Development' || env == 'Canary' || env == 'local') && false">
                    <b-nav-item :to="{ path: '/engagement/facebook-ads' }" v-if="permission.hasAccess('engagement.facebook-ads')">
                        Facebook
                    </b-nav-item>
                </template>
            </b-nav>
        </div>
    </div>
</template>

<script>
import permission from "../../services/user.permission";
import { mapState } from "vuex";

export default {
    name: "engagement-nav",
    data() {
        return {
            msg: "Engagement Nav",
            permission: permission,
            env: process.env.VUE_APP_MODE
        };
    },
    computed: {
        ...mapState("auth", ["planId", "unavailableToPlan"])
    }
};
</script>

<style scoped>
</style>
